import { ILabel, ILabelsParser, ILanguageRules } from "./Interfaces";

export class PoEditorLabelsParser implements ILabelsParser
{
    public async parse(labels: IPoEditorLabels): Promise<Map<string, ILabel>>
    {
        const indexedLabels = new Map<string, ILabel>();
        if (Array.isArray(labels))
        {
            for (let label of labels)
            {
                const isSimple = typeof (label.definition) == 'string';

                indexedLabels.set(
                    label.term,
                    {
                        key: label.term,
                        value: (isSimple ? label.definition as string : ''),
                        zero: (isSimple ? '' : (label.definition as IPoEditorLabelDefinition).zero ?? ''),
                        one: (isSimple ? '' : (label.definition as IPoEditorLabelDefinition).one ?? ''),
                        two: (isSimple ? '' : (label.definition as IPoEditorLabelDefinition).two ?? ''),
                        few: (isSimple ? '' : (label.definition as IPoEditorLabelDefinition).few ?? ''),
                        many: (isSimple ? '' : (label.definition as IPoEditorLabelDefinition).many ?? ''),
                        other: (isSimple ? '' : (label.definition as IPoEditorLabelDefinition).other ?? ''),
                    }
                );
            }
        }
        else if (typeof (labels) == "object")
        {
            for (let term in labels)
            {
                indexedLabels.set(
                    term,
                    {
                        key: term,
                        value: labels[term],
                        zero: '',
                        one: '',
                        two: '',
                        few: '',
                        many: '',
                        other: '',
                    }
                );
            }
        }
        return indexedLabels;
    }
}

type IPoEditorLabels = (IPoEditorSimpleLabels | IPoEditorComplexLabels)
type IPoEditorSimpleLabels = { [key: string]: string }
type IPoEditorComplexLabels = IPoEditorLabel[];

interface IPoEditorLabel
{
    term: string;
    definition: string | IPoEditorLabelDefinition;
    context?: string;
    term_plural?: string;
    reference?: string;
    comment?: string;
}

interface IPoEditorLabelDefinition
{
    zero?: string;
    one?: string;
    two?: string;
    few?: string;
    many?: string;
    other: string;
}
